export type DateTimeMode = 'date' | 'time' | 'datetime';

const SLOT_MINUTES = 15;

/** Snaps forward to the next 15-min-aligned slot from `now`. */
export function snapToNextSlot(now = new Date(), intervalMinutes = SLOT_MINUTES): Date {
  const ms = intervalMinutes * 60 * 1000;
  return new Date(Math.ceil(now.getTime() / ms) * ms);
}

/** Returns `start` + `offsetMinutes`. */
export function offsetDate(start: Date, offsetMinutes: number): Date {
  return new Date(start.getTime() + offsetMinutes * 60 * 1000);
}
